module.exports = __webpack_public_path__ + "img/good.5e603142.svg";